import { defineComponent as _defineComponent } from 'vue'
import {
  Modal,
  HeadingDisplay,
  Heading,
  ContentDisplay,
  ListDisplay
} from '@warrenbrasil/nebraska-web';
import { Portal } from '@/modules/common/components/Portal';

import { IDetails } from '@/modules/transaction/services/unified-account';

interface Props {
  isOpen: boolean;
  details: IDetails;
}
interface EmitEvents {
  (event: 'close'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BalanceDetailsModal',
  props: {
    isOpen: { type: Boolean },
    details: null
  },
  emits: ["close"],
  setup(__props: any) {





return { __sfc: true,Modal, HeadingDisplay, Heading, ContentDisplay, ListDisplay, Portal }
}

})